import type { IconName } from '@ui';
import type { Condition } from './api';

/** `MM-DD` or `YYYY-MM-DD` → `15.04.` */
export function dayMonth(value: string): string {
  const [m, d] = value.slice(-5).split('-');
  return `${d}.${m}.`;
}

/** `15.04.` or `15.4` → `04-15`; `null` if invalid, `undefined` if empty. */
export function parseDayMonth(value: string): string | null | undefined {
  const v = value.trim();
  if (!v) return undefined;
  const match = /^(\d{1,2})\.(\d{1,2})\.?$/.exec(v);
  if (!match) return null;
  const day = Number(match[1]);
  const month = Number(match[2]);
  const probe = new Date(Date.UTC(2025, month - 1, day));
  if (probe.getUTCMonth() !== month - 1 || probe.getUTCDate() !== day) return null;
  return `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function period(start: string, end: string): string {
  return `${dayMonth(start)}–${dayMonth(end)}`;
}

export const conditionIcon: Record<Condition, IconName> = {
  clear: 'sun',
  partly_cloudy: 'cloud-sun',
  cloudy: 'cloud',
  fog: 'cloud-fog',
  drizzle: 'cloud-rain',
  rain: 'cloud-rain',
  snow: 'cloud-snow',
  thunderstorm: 'cloud-lightning',
  wind: 'wind',
  unknown: 'cloud',
};

const number = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });

export function formatNumber(value: number): string {
  return number.format(value);
}

export function formatTemp(value: number): string {
  return `${Math.round(value)} °C`;
}
